import { apiPrivate } from './api';

export const SUGGESTION_STATUSES = ['pendente', 'em_analise', 'aprovada', 'recusada'];

export const SUGGESTION_STATUS_LABEL = {
  pendente: 'Pendente',
  em_analise: 'Em análise',
  aprovada: 'Aprovada',
  recusada: 'Recusada'
};

export const suggestionService = {
  create:        (data)             => apiPrivate.post('/api/suggestions', data).then((r) => r.data),
  adminGetAll:   (params)           => apiPrivate.get('/api/admin/suggestions', { params }).then((r) => r.data),
  pendingCount:  ()                 => apiPrivate.get('/api/admin/suggestions/pending-count').then((r) => Number(r.data?.pending_count) || 0),
  updateStatus:  (id, data)         => apiPrivate.patch(`/api/admin/suggestions/${id}`, data).then((r) => r.data)
};
